// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-newsletter-popup{overflow-x:hidden;overflow-y:auto}.czt-newsletter-popup__content{color:#fff}.czt-newsletter-popup__return{top:0.3125rem;left:0.3125rem}.czt-newsletter-popup__email .czt-recaptcha-wrapper .grecaptcha-badge{position:absolute !important}", ""]);
// Exports
module.exports = exports;
